var exports = {
  "kL": "x61f99309--9fe41b--container",
  "pq": "x61f99309--9fe41b--info",
  "my": "x61f99309--9fe41b--avatar",
  "hJ": "x61f99309--9fe41b--counter",
};

module.exports = exports;
